import { scrollToElement } from '../../../utils/eventUtils';

export const NO_TIMELINE_TYPE = 'No timeline types';

export const initialErrorState = {};

export const validate = (selectedTimelineTypes) => {
    let newErrors = {};

    if (selectedTimelineTypes.length < 1) {
        newErrors = {
            ...newErrors,
            timelineTypeId: { error: true, message: NO_TIMELINE_TYPE }
        };
    }

    // TODO This isn't working.
    scrollToElement(newErrors);

    return newErrors;
};
